module.exports = __webpack_public_path__ + "static/media/perfil_japa.7ebf6e8c.jpeg";